
export default {
  name: 'TranslationsAppForDevs',

  data(): Record<string, unknown> {
    return {
      rawJSON: [] as unknown,
      rawTrArray: [] as unknown,
      enJSON: {} as unknown,
      frJSON: {} as unknown,
      deJSON: {} as unknown,
      nlJSON: {} as unknown,
      plJSON: {} as unknown,
    };
  },

  methods: {
    convert(): void {
      this.rawTrArray = JSON.parse(this.rawJSON);

      this.enJSON = this.getLanguageJSON('en');
      this.frJSON = this.getLanguageJSON('fr');
      this.deJSON = this.getLanguageJSON('de');
      this.nlJSON = this.getLanguageJSON('nl');
      this.plJSON = this.getLanguageJSON('pl');
    },

    getLanguageJSON(lang: string): Record<string, string> | string {
      const obj: Record<string, string> = {};

      this.rawTrArray.map((singleTranslation: Record<string, string>) => {
        const objKey: string = singleTranslation.varname;
        const objVal: string = singleTranslation[lang];

        obj[objKey] = objVal;
      });

      const finObj: string = JSON.stringify(obj);
      return finObj;
    },
  },
};
